<div>

    <div *ngIf="loadingWaiver" style="margin-top: 32px;display: flex;justify-content: center;">
        <p-progressSpinner [style]="{ width: '40px', height: '40px' }" animationDuration=".5s">
        </p-progressSpinner>
    </div>

    <div class="tab-container" *ngIf="!loadingWaiver && waivers && waivers.length > 0">
        <div class="waiver-tab-container">
            <div *ngFor="let waiver of waivers; let i = index;" class="waiver-tab"
                 [ngClass]="{'selected': waiver.tab === selectedTab}" (click)="selectedTab = waiver.tab">
                <div>{{ waiver.label | translate }}</div>
            </div>
        </div>
    </div>

    <div *ngIf="!loadingWaiver && waivers && waivers.length === 0" class="no-waivers">
        {{ 'bikeshop.modal.update_job_card.no_waivers' | translate }}
    </div>

    <div class="margin-top-16" *ngIf="selectedTab === 'PREWAIVER'">
        <div>
            <div class="row-flex" *ngIf="preServiceWaiver.signatureURL && preServiceWaiver.signedDate">
                <div>
                    <iframe [src]="preServiceWaiverURLSafe"
                            frameborder="0"></iframe>
                </div>
                <div>
                    <div>
                        <a [href]="preServiceWaiverURL" target="_blank">
                            <qrcode [qrdata]="preServiceWaiverURL" colordark="rgba(30, 30, 30, 1)"
                                    [width]="125"
                                    [errorCorrectionLevel]="'M'"
                                    usesvg="true">
                            </qrcode>
                        </a>
                    </div>
                </div>
            </div>

            <div class="row-flex" *ngIf="!(preServiceWaiver.signatureURL && preServiceWaiver.signedDate)">
                <div class="not-signed">
                    {{ 'bikeshop.modal.update_job_card.pre_service_not_signed' | translate }}
                </div>
                <div>
                    <div>
                        <a [href]="preServiceWaiverURL" target="_blank">
                            <qrcode [qrdata]="preServiceWaiverURL" colordark="rgba(30, 30, 30, 1)"
                                    [width]="125"
                                    usesvg="true">
                            </qrcode>
                        </a>
                    </div>
                </div>
            </div>
        </div>

    </div>

    <div class="margin-top-16" *ngIf="selectedTab === 'POSTWAIVER'">
        <div>

            <div class="row-flex"
                 *ngIf="!postServiceWaiver.customerSignatureURL && !postServiceWaiver.customerSignedDate">
                <div
                        class="not-signed">
                    {{ 'bikeshop.modal.update_job_card.post_service_not_signed' | translate }}
                </div>
                <div>
                    <div>
                        <a [href]="postServiceCustomerWaiverURL" target="_blank">
                            <qrcode [qrdata]="postServiceCustomerWaiverURL" colordark="rgba(30, 30, 30, 1)"
                                    [width]="125"
                                    usesvg="true">
                            </qrcode>
                        </a>
                    </div>
                    <div class="waiver-type">{{ 'bikeshop.modal.update_job_card.waiver.customer_waiver' | translate }}</div>
                </div>
            </div>
            <div class="row-flex"
                 *ngIf="((waiverConfig.postServiceWaiverTechnicianSignatureRequired && !jobcard.IsFitting) || (jobcard.IsFitting && waiverConfig.postFittingWaiverFitterSignatureRequired)) && !postServiceWaiver.technicianSignatureURL && !postServiceWaiver.technicianSignedDate">
                <div *ngIf="waiverConfig.postFittingWaiverFitterSignatureRequired && jobcard.IsFitting && !postServiceWaiver.technicianSignatureURL && !postServiceWaiver.technicianSignedDate"
                     class="not-signed">
                    {{ 'bikeshop.modal.update_job_card.post_service_fitter_not_signed' | translate }}
                </div>
                <div
                        *ngIf="waiverConfig.postServiceWaiverTechnicianSignatureRequired && !jobcard.IsFitting && !postServiceWaiver.technicianSignatureURL && !postServiceWaiver.technicianSignedDate"
                        class="not-signed">
                    {{ 'bikeshop.modal.update_job_card.post_service_technician_not_signed' | translate }}
                </div>
                <div>
                    <div>
                        <a [href]="postServiceTechnicianWaiverURL" target="_blank">
                            <qrcode [qrdata]="postServiceTechnicianWaiverURL" colordark="rgba(30, 30, 30, 1)"
                                    [width]="125"
                                    usesvg="true">
                            </qrcode>
                        </a>
                    </div>
                    <div class="waiver-type">{{ (jobcard.IsFitting ? 'bikeshop.modal.update_job_card.waiver.fitter_waiver' :
                        'bikeshop.modal.update_job_card.waiver.technician_waiver') | translate }}</div>
                </div>
            </div>
            <div class="row-flex"
                 *ngIf="((waiverConfig.postFittingWaiverManagerSignatureRequired && jobcard.IsFitting ) || (waiverConfig.postServiceWaiverWorkShopManagerSignatureRequired && !jobcard.IsFitting)) && !postServiceWaiver.workshopManagerSignatureURL && !postServiceWaiver.workshopManagerSignedDate">
                <div
                        class="not-signed">
                    {{ 'bikeshop.modal.update_job_card.post_service_manager_not_signed' | translate }}
                </div>
                <div>
                    <div>
                        <a [href]="postServiceManagerWaiverURL" target="_blank">
                            <qrcode [qrdata]="postServiceManagerWaiverURL" colordark="rgba(30, 30, 30, 1)"
                                    [width]="125"
                                    usesvg="true">
                            </qrcode>
                        </a>
                    </div>
                    <div class="waiver-type">{{ 'bikeshop.modal.update_job_card.waiver.manager_waiver' | translate }}</div>
                </div>
            </div>

            <div class="row-flex"
                 *ngIf="postServiceWaiver.customerSignatureURL && postServiceWaiver.customerSignedDate">
                <div>
                    <iframe [src]="postServiceCustomerWaiverURLSafe"
                            frameborder="0"></iframe>
                </div>
                <div>
                    <div>
                        <a [href]="postServiceCustomerWaiverURL" target="_blank">
                            <qrcode [qrdata]="postServiceCustomerWaiverURL" colordark="rgba(30, 30, 30, 1)"
                                    [width]="125"
                                    usesvg="true">
                            </qrcode>
                        </a>
                    </div>
                </div>
            </div>

        </div>
    </div>

</div>
